/* Copper Vibrations 2026 theme runtime: hamburger menu, cart form helpers. */
(function () {
  function initMenu() {
    var burger = document.querySelector("[data-cv-burger]");
    var menu = document.querySelector("[data-cv-menu]");
    var scrim = document.querySelector("[data-cv-scrim]");
    if (!burger || !menu || !scrim) return;
    function set(open) {
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      burger.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      burger.classList.toggle("cv-burger-open", open);
      menu.hidden = !open;
      scrim.hidden = !open;
    }
    set(false);
    burger.addEventListener("click", function () {
      set(burger.getAttribute("aria-expanded") !== "true");
    });
    scrim.addEventListener("click", function () { set(false); });
    menu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { set(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") set(false);
    });
  }

  function initQty() {
    document.querySelectorAll("[data-cv-qty]").forEach(function (box) {
      var input = box.querySelector("input");
      box.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          var v = parseInt(input.value || "1", 10) || 1;
          v += b.dataset.dir === "down" ? -1 : 1;
          input.value = Math.max(parseInt(input.min || "1", 10) || 1, v);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  function initVariantPicker() {
    document.querySelectorAll("[data-cv-product]").forEach(function (root) {
      var select = root.querySelector("[data-cv-variant]");
      var priceEl = root.querySelector("[data-cv-price]");
      var button = root.querySelector("[data-cv-add]");
      var idInput = root.querySelector('input[name="id"]');
      var media = root.querySelectorAll("[data-cv-media]");
      var thumbs = root.querySelectorAll("[data-cv-thumb]");
      var money = root.dataset.moneyFormat || "${{amount}}";
      function fmt(cents) {
        var n = (cents / 100).toFixed(2);
        var parts = n.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return money.replace(/\{\{\s*amount\s*\}\}/, parts.join(".")).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
      }
      function showMedia(id) {
        media.forEach(function (m) { m.hidden = String(m.dataset.cvMedia) !== String(id); });
        thumbs.forEach(function (t) { t.setAttribute("aria-current", String(t.dataset.cvThumb) === String(id) ? "true" : "false"); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () { showMedia(t.dataset.cvThumb); });
      });
      if (!select) return;
      select.addEventListener("change", function () {
        var opt = select.options[select.selectedIndex];
        if (idInput) idInput.value = opt.value;
        if (priceEl && opt.dataset.price) priceEl.textContent = fmt(parseInt(opt.dataset.price, 10));
        if (button) {
          var ok = opt.dataset.available === "true";
          button.disabled = !ok;
          button.querySelector("[data-cv-add-label]").textContent = ok ? button.dataset.labelAdd : button.dataset.labelSold;
        }
        if (opt.dataset.media) showMedia(opt.dataset.media);
      });
    });
  }

  function initQuickAdd() {
    document.querySelectorAll("form[data-cv-quick-add]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("button");
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = "Adding…";
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 }) })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
          .then(function () { btn.textContent = "Added — view cart"; btn.disabled = false; btn.type = "button"; btn.onclick = function () { location.href = "/cart"; }; })
          .catch(function () { btn.textContent = label; btn.disabled = false; });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMenu(); initQty(); initVariantPicker(); initQuickAdd();
  });
})();
